import LabelNew from './LabelNew';

export default LabelNew;
